import modal from '../smartpak/modal';

export default function productFilterModal($content, { onOpen, onApply, onCancel }) {
    if (typeof onApply !== 'function') {
        throw new Error('productFilterModal requires an "onApply" function option.');
    }

    const actions = {
        APPLY: 'Apply',
        CANCEL: 'Cancel'
    };

    let lastAction;

    modal($content, {
        title: 'Filter Products',
        open: () => {
            if (typeof onOpen === 'function') {
                onOpen();
            }
        },
        close: () => {
            if (lastAction !== actions.APPLY && typeof onCancel === 'function') {
                onCancel();
            }
        },
        buttons: [
            {
                text: actions.APPLY,
                click: (modalInstance) => {
                    lastAction = actions.APPLY;

                    if (onApply()) {
                        modalInstance.close();
                    }
                }
            },
            {
                text: actions.CANCEL,
                click: (modalInstance) => {
                    modalInstance.close();

                    lastAction = actions.CANCEL;
                }
            }
        ]
    });
}